__turbopack_context__.v({
  "container": "Link-module-scss-module__wKC3Aq__container",
  "text": "Link-module-scss-module__wKC3Aq__text",
});
